import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { BookIllustrationComponent } from './book-illustration.component';

/** Клиент ждёт фотографа (альбом ученика, книга по ссылке): вместо голой заглушки — раскрытая книга, рамки которой «дышат».
 *  Картинок и иконок в проекте под это нет, поэтому книга собрана блоками на токенах.
 *  Хост тянется на весь остаток высоты раздела и держит блок по центру: ждать здесь больше нечего. */
@Component({
  selector: 'app-album-design-waiting',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BookIllustrationComponent],
  host: { class: 'grid flex-1 place-items-center' },
  template: `
    <div class="mx-auto w-full max-w-lg px-4 py-10 text-center">
      <!-- Разворот альбома как в прототипе: белые страницы, серые блоки фото дышат, пока фотограф собирает. -->
      <div class="flex justify-center">
        <app-book-illustration variant="spread" [pending]="true" />
      </div>

      <h3 class="mt-7 text-xl font-semibold" [class]="tone() === 'on-light' ? 'text-[var(--ink-on-light)]' : 'text-ink'">
        {{ title() }}
      </h3>
      @if (description()) {
        <p class="mx-auto mt-1.5 max-w-[var(--max-w-copy)] text-sm text-c2">{{ description() }}</p>
      }
      <!-- Действие даёт вызывающий: ждать нечего, когда экран просто «фотограф работает», но сбой на
           нашей стороне повтором лечится. -->
      <ng-content />
    </div>
  `,
})
export class AlbumDesignWaitingComponent {
  readonly title = input.required<string>();
  readonly description = input.required<string>();
  /** `on-light`: the block sits on an always-white page (album spread), where theme `ink` turns near-white in dark. */
  readonly tone = input<'ink' | 'on-light'>('ink');
}
